import PropTypes from 'prop-types';
import React from 'react';
import lazyLoadEnhancer from 'decorators/lazyLoad';
import { CoreImage } from 'components/core/library/image';

function Image({
	alt,
	className,
	src,
	flexImage,
	role,
	titleIcon,
	height,
	width,
	onClick,
	forceLazyLoad = false,
	fetchPriority,
	ariaHidden,
}) {
	return (
		<CoreImage
			alt={alt}
			src={src}
			role={role}
			flexImage={flexImage}
			titleIcon={titleIcon}
			className={className}
			height={height}
			onClick={onClick}
			width={width}
			loading={fetchPriority === 'high' ? undefined : ((src.includes(".webp") || forceLazyLoad) ? "lazy" : undefined)}
			fetchPriority={fetchPriority}
			aria-hidden={ariaHidden}
		/>
	);
}

Image.propTypes = {
	/** The alt tag for the image */
	alt: PropTypes.string,
	/** The path to the image source */
	src: PropTypes.string.isRequired,
	/** transforms the image into a background that is set to cover the container */
	flexImage: PropTypes.bool,
	/** optional image class name */
	className: PropTypes.string,
	/** Make image vertically centered with text with right margin */
	titleIcon: PropTypes.bool,
	/** accessibility role */
	role: PropTypes.string,
	height: PropTypes.string,
	width: PropTypes.string,
	onClick: PropTypes.func,
	forceLazyLoad: PropTypes.bool,
	fetchPriority: PropTypes.oneOf(['high', 'low', 'auto']),
	/** hide image from assistive technology */
	ariaHidden: PropTypes.bool,
};

const LazyImage = lazyLoadEnhancer(Image);

function EnhancedImage({ lazyLoad = true, ...props }) {
	if (lazyLoad) return <LazyImage {...props} />;
	return <Image {...props} />;
}

export default EnhancedImage;
